(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('Allergies', Allergies);

    Allergies.$inject = ['$resource', 'DateUtils'];

    function Allergies ($resource, DateUtils) {
        var resourceUrl =  'api/allergies/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.reactionDate = DateUtils.convertDateTimeFromServer(data.reactionDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'findAllByChart': {url: 'api/allergies/by-chart/:id', method: 'GET', isArray: true},
            'findAllByChartAndStatus': {url: 'api/allergies/by-chart/:id/:status', method: 'GET', isArray: true},
            'findAllAllergiesByChart': {url: 'api/allergies/by-allergen/:id/:allergenType', method: 'GET', isArray: true},
            'findAllByFilter': {url: 'api/allergies/by-chart', method: 'GET', isArray: true},
        });
    }
})();


